import { adminFetch } from "./base";

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export type AnnouncementPriority = "haute" | "normale";

export interface Announcement {
  readonly id: string;
  readonly title: string;
  readonly body: string;
  readonly priority: AnnouncementPriority;
  readonly is_pinned: boolean;
  readonly target_departments: readonly string[] | null;
  readonly author_id: string;
  readonly author_name: string;
  readonly read_count: number;
  readonly total_targets: number;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface AnnouncementListResponse {
  readonly announcements: readonly Announcement[];
  readonly pagination: {
    readonly page: number;
    readonly limit: number;
    readonly total: number;
  };
}

export interface AnnouncementFilters {
  readonly priority?: AnnouncementPriority;
  readonly is_pinned?: boolean;
  readonly page?: number;
  readonly limit?: number;
}

export interface CreateAnnouncementInput {
  readonly title: string;
  readonly body: string;
  readonly priority: AnnouncementPriority;
  readonly is_pinned?: boolean;
  readonly target_departments?: readonly string[];
}

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

function buildQuery(filters: AnnouncementFilters): string {
  const params = new URLSearchParams();
  if (filters.priority) params.set("priority", filters.priority);
  if (filters.is_pinned !== undefined) params.set("is_pinned", String(filters.is_pinned));
  if (filters.page) params.set("page", String(filters.page));
  if (filters.limit) params.set("limit", String(filters.limit));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

// ---------------------------------------------------------------------------
// API module
// ---------------------------------------------------------------------------

export const announcementsApi = {
  list: (filters: AnnouncementFilters = {}) =>
    adminFetch<AnnouncementListResponse>(
      `/api/admin/team/announcements${buildQuery(filters)}`,
    ),

  create: (input: CreateAnnouncementInput) =>
    adminFetch<{ announcement: Announcement }>("/api/admin/team/announcements", {
      method: "POST",
      body: JSON.stringify(input),
    }),
} as const;
